<template>
  <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;">
    <v-layout row style="width:100%;">
      <v-flex d-flex md4 style="max-width:33%;">
        <v-card style="width:100%;height:100%;">
          <v-card-title primary class="title" style="height:5%;">Fault list</v-card-title>
          <v-card-actions fill-height style="height:95%;">
            <v-layout column fill-height>
              <v-flex d-flex md1>
                <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="dateText"
                        label="Date range"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-layout column style="background-color:white;">
                    <v-layout row>
                      <v-flex d-flex md6>
                        <v-date-picker
                            v-model="startDate"
                            color='rgb(51,82,128)'
                            :max="endDate"/>
                      </v-flex>
                      <v-flex d-flex md6>
                        <v-date-picker
                            v-model="endDate"
                            color='rgb(51,82,128)'
                            :min="startDate"
                            :max="maxDate"/>
                      </v-flex>
                    </v-layout>
                    <v-layout row style="justify-content:flex-end;">
                      <v-btn style="color: rgb(51,82,128);" @click="getData()" text flat>OK</v-btn>
                      <v-btn style="color: rgb(51,82,128);" @click="dateMenu=false" text flat>Cancel</v-btn>
                    </v-layout>
                  </v-layout>
                </v-menu>
              </v-flex>
              <v-flex d-flex md1>
                <v-autocomplete
                    v-model="filter['fault']"
                    :items="allFaults"
                    placeholder='Fault'
                    v-on:change="filterFaults()"
                    item-text='text' item-value='value'/>
              </v-flex>
              <v-flex d-flex md1>
                <v-layout row>
                  <v-flex d-flex md6>
                    <v-autocomplete
                        v-model="filter['element']"
                        :items="allComponents"
                        placeholder='Component'
                        v-on:change="filterFaults()"
                        item-text='text' item-value='value'/>
                  </v-flex>
                  <v-flex d-flex md6>
                    <v-autocomplete
                        v-model="filter['component']"
                        :items="allSubsystems"
                        placeholder='Subsystem'
                        v-on:change="filterFaults()"
                        item-text='text' item-value='value'/>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md9 style="overflow:auto;">
                <dx-data-grid
                    id="table"
                    ref="faultGrid"
                    style="width:100%;height:100%;"
                    :data-source="faults"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :show-borders="false"
                    :word-wrap-enabled="true"
                    :row-alternation-enabled="false"
                    :column-auto-width="true"
                    :selection="{ mode: 'single' }"
                    :hover-state-enabled="true"
                    @selection-changed="selFaultChange"
                    @contentReady="gridLoaded">
                  <dx-column
                      data-field="fault"
                      caption="Description"/>
                  <dx-column
                      data-field="element"
                      caption="Element"/>
                  <dx-column
                      data-field="index"
                      caption="Index"
                      alignment="left"/>
                  <dx-column
                      data-field="component"
                      caption="Subsystem"/>
                  <dx-column
                      data-field="subComponent"
                      caption="Component"/>
                  <dx-column
                      data-field="formatedDate"
                      caption="Date"
                      :allow-sorting="true"
                      :sort-order="'asc'"/>
                </dx-data-grid>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex d-flex md8>
        <v-tabs v-model="active" slider-color="rgb(51,82,128)" style="height:100%;width:100%;">
          <v-tab v-for="title in tabTitles" :key="title" ripple active-class='activeTab' style="text-transform:none;color:rgb(192,192,192);">
            <span>{{ title }}</span>
          </v-tab>
          <v-tab-item class="tabItem">
            <EngineFaultsDataNewRules v-if="selFault && selFault.subsystem" v-bind:fault="selFault" v-bind:active="tabActive[0]"/>            
            <EngineFaultsData v-else v-bind:fault="selFault" v-bind:active="tabActive[0]"/>
          </v-tab-item>
          <v-tab-item class="tabItem">
            <EngineFaultsDetailsNewRules v-if="selFault && selFault.subsystem" v-bind:history="true" v-bind:fault="selFault" v-bind:active="tabActive[1]"/>
            <EngineFaultsDetails v-else v-bind:history="true" v-bind:fault="selFault" v-bind:active="tabActive[1]"/>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import EngineFaultsData from "./EngineFaultsData"
import EngineFaultsDetails from "./EngineFaultsDetails"
import EngineFaultsDataNewRules from "./EngineFaultsDataNewRules"
import EngineFaultsDetailsNewRules from "./EngineFaultsDetailsNewRules"

import {DxColumn, DxDataGrid, DxPaging, DxScrolling, DxSorting} from 'devextreme-vue/data-grid';
import FaultCard from '../controls/FaultCard'

import {DxFieldChooser, DxPivotGrid} from 'devextreme-vue/pivot-grid';

import axios from 'axios';

import {globalStore} from "../main.js"
import {getData} from "../getData.js";

let apiService;

export default {
  name: 'FaultsHistory',
  components: {
    EngineFaultsData,
    EngineFaultsDetails,
    EngineFaultsDataNewRules,
    EngineFaultsDetailsNewRules,
    FaultCard,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling,
    DxSorting,
    DxPivotGrid, DxFieldChooser
  },
  data() {
    return {
      active: parseInt(this.$route.query.tab),
      tabTitles: [
        'Fault Data', 'Details'
      ],
      faults: [],
      allFaults: [],
      allComponents: [],
      allSubsystems: [],
      kpi: {},
      selectedFaultId: -1,
      tabActive: [false, false],
      filter:
          {
            element: null,
            component: null,
            fault: null
          },
      startDate: '',
      endDate: '',
      dateMenu: false,
      selFault: {},
      faultToBeLoaded: null
    }
  },
  created() {

  },
  mounted() {
    apiService = new getData(globalStore.userProfile);

    this.endDate = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substring(0, 10);
    this.startDate = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10);

    if (globalStore.selectedIMO) {
      this.getData();
    }
  },
  methods: {
    filterFaults: function () {
      const dataGrid = this.$refs['faultGrid'].instance;

      let filterArray = [];

      Object.keys(this.filter).forEach(key => {
        let val = this.filter[key];

        if (val != null) {
          if (filterArray.length > 0) filterArray.push('and');

          filterArray.push(val);
        }
      })

      if (filterArray.length > 0) {
        dataGrid.filter(filterArray);
      } else {
        dataGrid.clearFilter();
      }
    },
    selFaultChange(e) {
      if (e.selectedRowsData.length > 0) {
        let srData = e.selectedRowsData[0];

        this.selectedFaultId = srData.Id;

        // getData.
        // apiService.getData('last', globalStore.selectedIMO);

        this.faultToBeLoaded = this.faults.find(function (item) {
          return ((item.Id == this.selectedFaultId) && (item.fault == srData.fault) && (item.index == srData.index) && (item.startDate == srData.startDate));
        }, this);
      } else {
        this.selectedFaultId = -1;
        this.selFault = undefined;
      }
    },
    async getData() {
      this.dateMenu = false;

      globalStore.loading = true;

      let url = new URL(globalStore.config.api_location + '/getWiDEFaultDataPerVesselForDateRange/' + globalStore.selectedIMO + '/' + this.startDate + '/' + this.endDate),
          response = await axios
              .get(url.toString(), {headers: {Authorization: globalStore.auth_token}})
              .catch(function (e) {
              });

      if (
          typeof response != 'undefined'
          && response.status == 200
          && Object.keys(response.data).indexOf('data') > -1
          && Object.keys(response.data.data).length > 0
      ) {
        let faultDict;

        if (globalStore.selectedEngine != '') {
          if (typeof faultDict === 'string') {
            faultDict = JSON.parse(response.data.data[globalStore.selectedEngine]);
          } else {
            faultDict = response.data.data[globalStore.selectedEngine];
          }
        } else {
          if (typeof faultDict === 'string') {
            faultDict = JSON.parse(response.data.data.Port);
          } else {
            faultDict = response.data.data.Port;
          }
        }

        if (Object.keys(faultDict).length) {
          this.faults = Object.values(faultDict);
          this.faults.forEach(item=>{
            if (item.subComponent =='')
            {
              item.subComponent = item.component;
              item.component =item.subsystem ;
            }
          })
        } else
          this.faults = [];
      } else
        this.faults = [];

      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds

      // let isAdmin = globalStore.userProfile.roles.includes('ROLE_WINGD_USER')
      //     || globalStore.userProfile.roles.includes('ROLE_WINGD_ADMIN')
      //     || globalStore.userProfile.roles.includes('ROLE_WINGD_SUPER_ADMIN');
      let isAdmin = globalStore.userProfile.company == 'Propulsion Analytics';

      if (!isAdmin) {
        this.faults = this.faults.filter(fault => {
          let code = fault.events[0].code;
          return !globalStore.config.disabled_rules.some(item => code.startsWith(item));
        })
      }

      this.faults = this.faults.map(function (item) {
        let date = new Date(item['endDate']);
        let formatted_date = (new Date(date - tzoffset)).toISOString().replace('T', ' ').substring(0, 16);

        item['formatedDate'] = formatted_date;

        return item;
      });

      this.allComponents = [{text: 'All', value: null}];

      [...new Set(this.faults.map(item => item['element'] + ' ' + item['index']))].forEach(item => {

        let [el, index] = item.split(' ');

        this.allComponents.push({
          text: item,
          value: [['element', '=', el], 'and', ['index', '=', index]]
        })
      })

      this.allComponents.sort(function (a, b) {
        if (a.value == null) return -1;
        else if (b.value == null) return 1;
        else if (a.value[0][2] > b.value[0][2]) return 1;
        else if (a.value[0][2] < b.value[0][2]) return -1;
        else if (Number(a.value[2][2]) > Number(b.value[2][2])) return 1;
        else return -1;
      });

      this.allSubsystems = [{text: 'All', value: null}];

      [...new Set(this.faults.map(item => item['component']))].forEach(item => {
        this.allSubsystems.push({
          text: item,
          value: ['component', '=', item]
        })
      });

      this.allSubsystems.sort();

      this.allFaults = [{
        text: 'All (' + this.faults.length + ')',
        value: null
      }];

      [...new Set(this.faults.map(item => item['fault']))].forEach(fault => {

        let faultString = fault;

        faultString += ' (' + this.faults.filter(item => item['fault'] == fault).length + ')';

        this.allFaults.push({
          text: faultString,
          value: ['fault', '=', fault]
        });
      })

      this.allFaults.sort();

      globalStore.loading = false;
    },
    gridLoaded() {
      if ((this.faults.length > 0) && (this.selectedFaultId == -1))
        this.$refs['faultGrid'].instance.selectRowsByIndexes([0]);
    }
  },
  computed: {
    dateText: function () {
      return 'From ' + this.startDate + ' to ' + this.endDate;
    },
    maxDate: function () {
      return new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substring(0, 10);
    },
    selectedIMO: function () {
      return globalStore.selectedIMO
    }
  },
  watch: {
    active: function () {
      for (let i = 0; i < this.tabActive.length; i++) {
        if (i == this.active) this.tabActive[i] = true;
        else this.tabActive[i] = false;
      }
    },
    selectedIMO: function () {
      this.getData();
    },
    selectedFaultId: function (a, b) {
      if (this.faultToBeLoaded != null) {
        let target_date = new Date(`${this.faultToBeLoaded.startDate}+00:00`).toISOString().split('T')[0];

        // apiService.getData(target_date, globalStore.selectedIMO);
        this.selFault = this.faultToBeLoaded;
        this.faultToBeLoaded = null
      }
    }
  }
}
</script>

<style scoped>

.tabItem {
  height: calc(100vh - 157px)
}

.dx-datagrid-rowsview .dx-selection.dx-row > td,
.dx-datagrid-rowsview .dx-selection.dx-row:hover > td {
  background-color: #bf4e6a;
  color: #232323;
}

.dx-datagrid-table .dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row) > td:not(.dx-focused) {
  background-color: #bf4e6a;
  color: #333;
}

</style>